import React from "react";
import { object } from "prop-types";
import DownloadInvoices from "../download-invoice";

import "./plan-info.m.css";

const PlanInfo = ({ plan }) => {
  const getPlanDuration = () => {
    if (plan.duration_unit === "years") {
      return "(Anually)";
    } else if (plan.duration_unit === "months") {
      return plan.duration_length > 1 ? "(Quarterly)" : "(Monthly)";
    }
  };

  const getFormattedDate = (utcDate) => {
    const [yy, mm, dd] = utcDate.slice(0, 10).split("-");
    return `${dd}/${mm}/${yy}`;
  };

  return (
    <div styleName="plan-info-wrapper">
      <div styleName="plan-info">
        <span styleName="plan-title">Plan {`(${plan.plan_occurrence})`}:</span>
        <span styleName="plan-value">
          {plan.plan_name} {getPlanDuration()}
        </span>
      </div>

      <div styleName="plan-info">
        <span styleName="plan-title">Due Date:</span>
        <span styleName="plan-value">{getFormattedDate(plan.end_timestamp)}</span>
      </div>

      <div styleName="plan-info-download">
        <div>
          <span styleName="plan-title">Status:</span>
          <span styleName="plan-value">{plan.status}</span>
        </div>
        <DownloadInvoices plan={plan} />
      </div>
    </div>
  );
};

PlanInfo.propTypes = {
  plan: object,
};

export default PlanInfo;
